(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_step-electricity-bill"] && !Shopify.designMode) return;
  try {
    // Listen for electricity cost changes from the main calculator
  document.addEventListener('electricity-cost-changed', function (e) {
    const step = document.querySelector('#step-3');
    if (!step) return;

    const costDisplay = step.querySelector('#electricity-cost-display');
    if (!costDisplay) return;

    const cost = e.detail.cost;
    costDisplay.textContent = cost;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_step-results"] && !Shopify.designMode) return;
  try {
    // Listen for savings calculation updates from the main calculator
  document.addEventListener('savings-calculated', function (e) {
    const step = document.querySelector('#step-5');
    if (!step) return;

    const savingsAmount = step.querySelector('#savings-amount');
    if (!savingsAmount) return;

    // Get the shop's locale from the data attribute
    const locale = step.dataset.locale || 'en-US';
    const savings = e.detail.savings;

    // Format as currency with 2 decimal places using the shop's locale
    const formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(savings);

    savingsAmount.textContent = formatted;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_step-thermostat-count"] && !Shopify.designMode) return;
  try {
    // Listen for thermostat count changes from the main calculator
  document.addEventListener('thermostat-count-changed', function (e) {
    const step = document.querySelector('#step-2');
    if (!step) return;

    const icons = step.querySelectorAll('.icon');
    const count = e.detail.count;

    icons.forEach(function (icon) {
      const index = parseInt(icon.dataset.thermostatIndex);
      if (index <= count) {
        icon.classList.add('active');
      } else {
        icon.classList.remove('active');
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["app-download-buttons"] && !Shopify.designMode) return;
  try {
    const mobileQuery = window.matchMedia('(max-width: 767px)');
  const ua = navigator.userAgent || navigator.vendor || '';
  const isAndroid = /android/i.test(ua);

  class AppDownloadButtons extends HTMLElement {
    connectedCallback() {
      this.#applyDeviceOrder();
      mobileQuery.addEventListener('change', this.#applyDeviceOrder);
    }

    disconnectedCallback() {
      mobileQuery.removeEventListener('change', this.#applyDeviceOrder);
    }

    #applyDeviceOrder = () => {
      if (!mobileQuery.matches) return;

      const appStore = this.querySelector('[data-app-store]');
      const playStore = this.querySelector('[data-play-store]');
      if (!appStore || !playStore) return;

      appStore.classList.remove('app-download-buttons__btn--primary', 'app-download-buttons__btn--secondary');
      playStore.classList.remove('app-download-buttons__btn--primary', 'app-download-buttons__btn--secondary');

      if (isAndroid) {
        playStore.classList.add('app-download-buttons__btn--primary');
        appStore.classList.add('app-download-buttons__btn--secondary');
      } else {
        appStore.classList.add('app-download-buttons__btn--primary');
        playStore.classList.add('app-download-buttons__btn--secondary');
      }
    };
  }

  customElements.define('app-download-buttons', AppDownloadButtons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["feature-accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('feature-accordion-block')) {
    class FeatureAccordionBlock extends HTMLElement {
      // Cache for DOM elements
      #items = null;
      #itemData = new Map();

      constructor() {
        super();
        this.accordionGroup = this.querySelector('[data-accordion-group]');
        this.defaultImage = this.querySelector('[data-default-image]');
      }

      connectedCallback() {
        if (!this.accordionGroup) return;
        this.#cacheElements();
        this.#initAccordions();
        this.#bindAccordionEvents();
      }

      #cacheElements() {
        this.#items = this.accordionGroup.querySelectorAll('[data-accordion-item]');

        for (const item of this.#items) {
          const index = item.dataset.accordionItem;
          this.#itemData.set(item, {
            contentWrap: item.querySelector('.content-wrap'),
            image: this.querySelector(`[data-item-image="${index}"]`),
          });
        }
      }

      #initAccordions() {
        for (const item of this.#items) {
          const { contentWrap } = this.#itemData.get(item);
          if (contentWrap && !item.open) {
            contentWrap.style.height = '0';
            contentWrap.style.opacity = '0';
          }
        }
      }

      #bindAccordionEvents() {
        for (const item of this.#items) {
          const summary = item.querySelector('summary');
          if (!summary) continue;

          summary.addEventListener('click', (e) => {
            e.preventDefault();
            this.#toggleItem(item);
          });
        }
      }

      #toggleItem(item) {
        const { contentWrap } = this.#itemData.get(item);
        if (!contentWrap) return;

        const isOpening = !item.open;

        if (isOpening) {
          for (const otherItem of this.#items) {
            if (otherItem !== item && otherItem.open) {
              this.#closeItem(otherItem);
            }
          }
          this.#openItem(item);
          this.#updateImageVisibility(item);
        } else {
          this.#closeItem(item);
          this.#updateImageVisibility(null);
        }
      }

      #openItem(item) {
        const { contentWrap } = this.#itemData.get(item);
        if (!contentWrap) return;

        item.open = true;
        item.classList.add('is-open');

        if (typeof gsapGrowIn === 'function') {
          gsapGrowIn(contentWrap, { duration: 0.4, ease: 'power2.out' });
        } else {
          contentWrap.style.height = 'auto';
          contentWrap.style.opacity = '1';
        }
      }

      #closeItem(item) {
        const { contentWrap } = this.#itemData.get(item);
        if (!contentWrap) return;

        item.classList.remove('is-open');

        if (typeof gsapGrowOut === 'function') {
          gsapGrowOut(contentWrap, {
            duration: 0.3,
            ease: 'power2.in',
            hideAfter: false,
            onComplete: () => {
              item.open = false;
            },
          });
        } else {
          contentWrap.style.height = '0';
          contentWrap.style.opacity = '0';
          item.open = false;
        }
      }

      #updateImageVisibility(activeItem) {
        if (this.defaultImage) {
          this.defaultImage.classList.toggle('is-hidden', activeItem !== null);
        }

        for (const item of this.#items) {
          const { image } = this.#itemData.get(item);
          if (image) {
            image.classList.toggle('is-active', item === activeItem);
          }
        }
      }
    }

    customElements.define('feature-accordion-block', FeatureAccordionBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["iframe"] && !Shopify.designMode) return;
  try {
    const MAX_IFRAME_HEIGHT = 20000;

  class IframeEmbed extends HTMLElement {
    #iframe = null;
    #onMessage = null;
    #controller = null;

    connectedCallback() {
      this.#iframe = this.querySelector('iframe');
      if (!this.#iframe) return;

      if (this.hasAttribute('data-auto-height')) {
        this.#onMessage = this.#handleMessage.bind(this);
        window.addEventListener('message', this.#onMessage);
      }

      if (this.hasAttribute('data-show-count')) {
        this.#loadCount();
      }
    }

    disconnectedCallback() {
      if (this.#onMessage) window.removeEventListener('message', this.#onMessage);
      this.#controller?.abort();
    }

    #handleMessage(event) {
      if (event.source !== this.#iframe.contentWindow) return;

      const data = event.data;
      if (!data || data.type !== 'resize') return;

      const height = Number(data.height);
      if (!Number.isFinite(height) || height <= 0 || height > MAX_IFRAME_HEIGHT) return;

      this.style.setProperty('--iframe-height', `${Math.ceil(height)}px`);
    }

    async #loadCount() {
      const output = this.querySelector('.iframe-embed__count');
      const src = this.#iframe.getAttribute('src');
      if (!output || !src) return;

      this.#controller = new AbortController();

      try {
        const response = await fetch(src, { signal: this.#controller.signal });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const count = this.#countPositions(await response.text(), src);
        if (count <= 0) return;

        const template = count === 1 ? output.dataset.labelOne : output.dataset.labelOther;
        // Unhide before writing so the role="status" live region announces the change.
        output.hidden = false;
        output.textContent = (template ?? '').replace('[count]', String(count));
      } catch (error) {
        if (error.name !== 'AbortError') {
          // Data belongs to a third party — fail quietly and leave the count hidden.
        }
      }
    }

    #countPositions(html, src) {
      const embedId = this.#embedId(src);
      if (!embedId) return 0;

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const links = doc.querySelectorAll(`a[href*="/j/${CSS.escape(embedId)}/"]`);
      const ids = new Set();

      for (const link of links) {
        const match = (link.getAttribute('href') ?? '').match(/\/j\/[^/]+\/(\d+)/);
        if (match) ids.add(match[1]);
      }

      return ids.size;
    }

    #embedId(src) {
      const match = src.match(/\/embed\/([^/?#]+)/);
      return match ? match[1] : null;
    }
  }

  if (!customElements.get('iframe-embed')) {
    customElements.define('iframe-embed', IframeEmbed);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["launch-learn-more-hero"] && !Shopify.designMode) return;
  try {
    const publishLearnPageViewItem = () => {
    const el = document.querySelector('[data-learn-product-analytics]');

    if (!el) {
      return;
    }

    if (!Shopify.analytics) {
      return;
    }

    let productVariant;

    try {
      productVariant = JSON.parse(el.textContent);
    } catch (parseError) {
      return;
    }

    Shopify.analytics.publish('theme:learn_page_view_item', { productVariant });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', publishLearnPageViewItem, { once: true });
  } else {
    publishLearnPageViewItem();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["metaobject-product-button"] && !Shopify.designMode) return;
  try {
    /**
   * Interest form submission handler.
   *
   * Note: Email data is captured via Shopify's Web Pixels API (analytics.subscribe("form_submitted"))
   * which intercepts form submissions before this client-side handler runs. The pixel handler in
   * analytics/mysa-chunk.js processes forms with "product-interest" in the ID and posts them to Chunk.
   * This handler only manages the UI success state.
   */
  document.addEventListener('DOMContentLoaded', () => {
    const interestForms = document.querySelectorAll('.metaobject-interest-form');

    for (const form of interestForms) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();

        form.classList.add('is-submitted');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mysa-product-grid"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mysa-product-grid-component')) {
    class MysaProductGridComponent extends HTMLElement {
      #abortController = null;

      constructor() {
        super();
        this.sortMenu = this.querySelector('popover-menu-component');

        if (this.sortMenu) {
          this.sortMenu.addEventListener('popover-menu:select', this.#handleSortChange.bind(this));
        }
      }

      #handleSortChange(event) {
        const sortValue = event.detail.value;
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortValue);
        history.pushState({}, '', url.toString());
        this.#refreshSection();
      }

      async #refreshSection() {
        const sectionId = this.closest('.shopify-section')?.id?.replace('shopify-section-', '');
        if (!sectionId) return;

        // Abort any in-flight request to prevent race conditions
        if (this.#abortController) {
          this.#abortController.abort();
        }
        this.#abortController = new AbortController();

        const url = `${window.location.pathname}?section_id=${sectionId}&${window.location.search.slice(1)}`;

        try {
          const response = await fetch(url, { signal: this.#abortController.signal });
          if (!response.ok) throw new Error('Section fetch failed');

          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newContent = doc.querySelector('mysa-product-grid-component');

          if (newContent) {
            this.innerHTML = newContent.innerHTML;
            this.sortMenu = this.querySelector('popover-menu-component');

            if (this.sortMenu) {
              this.sortMenu.addEventListener('popover-menu:select', this.#handleSortChange.bind(this));
            }
          }
        } catch (error) {
          // Ignore abort errors - they're intentional
          if (error.name === 'AbortError') return;
          console.error('Error refreshing section:', error);
        }
      }
    }

    customElements.define('mysa-product-grid-component', MysaProductGridComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["mysa-text-input"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const blocks = document.querySelectorAll('.mysa-text-input-block');

    blocks.forEach(function (block) {
      const item = block.querySelector('.form_input-item');
      if (!item) return;

      const field = item.querySelector('.form_input-field');
      if (!field) return;

      const errorMessage = block.querySelector('.form_input-error');
      let hasBeenTouched = false;

      function showError() {
        item.classList.add('has-error');
        if (errorMessage) {
          errorMessage.removeAttribute('inert');
        }
      }

      function hideError() {
        item.classList.remove('has-error');
        if (errorMessage) {
          errorMessage.setAttribute('inert', '');
        }
      }

      function validateField() {
        if (!field.validity.valid) {
          showError();
        } else {
          hideError();
        }
      }

      // Only validate on blur if field has been touched AND has a value
      field.addEventListener('blur', function () {
        if (field.value.trim() !== '') {
          hasBeenTouched = true;
          validateField();
        }
      });

      // Browser native validation when form tries to submit
      field.addEventListener('invalid', function (e) {
        e.preventDefault();
        hasBeenTouched = true;
        showError();
      });

      // Live validation: only if already touched or showing error
      field.addEventListener('input', function () {
        if (hasBeenTouched || item.classList.contains('has-error')) {
          validateField();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    class Tabs {
    constructor(element) {
      this.tabs = element;
      this.blockId = element.dataset.blockId;
      this.nav = this.tabs.querySelector('[data-tabs-nav]');
      this.content = this.tabs.querySelector('[data-tabs-content]');
      this.items = Array.from(this.content.querySelectorAll('[data-tab-item]'));
      this.hasMobileDropdown = this.tabs.hasAttribute('data-mobile-dropdown');

      this.currentTab = 0;
      this.totalTabs = this.items.length;
      this.isAnimating = false;
      this.isMobileView = false;

      // AbortController for cleanup
      this.abortController = new AbortController();

      this.init();
    }

    init() {
      if (this.totalTabs === 0) return;

      // Setup accordion and check viewport before other operations that depend on mobile state
      if (this.hasMobileDropdown) {
        this.setupAccordion();
        this.checkViewport();
      }

      this.generateButtons();
      this.updateTabs();
      this.bindEvents();
      this.setupResizeObserver();
    }

    setupAccordion() {
      const signal = this.abortController.signal;

      // Bind accordion toggle events
      for (const item of this.items) {
        const toggle = item.querySelector('[data-accordion-toggle]');
        if (toggle) {
          toggle.addEventListener('click', () => this.toggleAccordion(item), { signal });
        }
      }

      // Listen for viewport changes
      this.mediaQuery = window.matchMedia('(max-width: 767px)');
      this.mediaQuery.addEventListener('change', () => this.checkViewport(), { signal });
    }

    checkViewport() {
      const wasMobile = this.isMobileView;
      this.isMobileView = this.mediaQuery?.matches || false;

      // Skip if no viewport change
      if (wasMobile === this.isMobileView) return;

      // When switching to mobile, expand first accordion if none open
      if (this.isMobileView) {
        const hasOpenAccordion = this.items.some((item) => item.classList.contains('is-open'));
        if (!hasOpenAccordion && this.items[0]) {
          this.items[0].classList.add('is-open');
          const toggle = this.items[0].querySelector('[data-accordion-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'true');
        }
      }

      // Update aria-hidden state based on new viewport
      this.updateTabs();
    }

    toggleAccordion(item) {
      const isExpanded = item.classList.contains('is-open');
      const toggle = item.querySelector('[data-accordion-toggle]');

      // Toggle the clicked item
      item.classList.toggle('is-open', !isExpanded);
      if (toggle) toggle.setAttribute('aria-expanded', !isExpanded);
    }

    applyContentHeight(px) {
      if (this.isMobileView && this.hasMobileDropdown) return;
      this.content.style.height = `${px}px`;
    }

    syncHeight() {
      const activeItem = this.items[this.currentTab];
      if (!activeItem) return;
      this.applyContentHeight(activeItem.offsetHeight);
    }

    setupResizeObserver() {
      this.resizeObserver = new ResizeObserver((entries) => {
        if (this.isAnimating) return;
        const entry = entries.find((record) => record.target === this.items[this.currentTab]);
        if (entry?.borderBoxSize?.[0]) {
          this.applyContentHeight(entry.borderBoxSize[0].blockSize);
          return;
        }
        this.syncHeight();
      });

      // Observe all tab content items
      for (const item of this.items) {
        this.resizeObserver.observe(item);
      }
    }

    generateButtons() {
      // Clear existing buttons
      this.nav.innerHTML = '';
      this.buttons = [];

      // Create button for each tab item
      this.nav.setAttribute('role', 'tablist');

      for (let i = 0; i < this.totalTabs; i++) {
        const item = this.items[i];
        const title = item.dataset.tabTitle || `Tab ${i + 1}`;
        const titleStyle = item.dataset.tabTitleStyle;
        const subtitle = item.dataset.tabSubtitle;
        const icon = item.dataset.tabIcon;
        const iconUrl = item.dataset.tabIconUrl;

        const button = document.createElement('button');
        const tabId = `tabs-tab-${this.blockId}-${i}`;
        const panelId = `tabs-panel-${this.blockId}-${i}`;

        button.className = 'tabs-nav-button';
        button.type = 'button';
        button.id = tabId;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-controls', panelId);
        button.dataset.tabsButton = i;
        button.setAttribute('aria-selected', i === 0);
        button.setAttribute('tabindex', i === 0 ? '0' : '-1');

        item.id = panelId;
        item.setAttribute('role', 'tabpanel');
        item.setAttribute('aria-labelledby', tabId);

        // Add icon if present
        if (icon) {
          const iconSpan = document.createElement('span');
          iconSpan.className = 'tabs-nav-button-icon';
          iconSpan.textContent = icon;
          button.appendChild(iconSpan);
        } else if (iconUrl) {
          const iconImg = document.createElement('img');
          iconImg.className = 'tabs-nav-button-icon-image';
          iconImg.src = iconUrl;
          iconImg.alt = '';
          iconImg.setAttribute('aria-hidden', 'true');
          iconImg.loading = 'lazy';
          button.appendChild(iconImg);
        }

        // Add text wrapper for title and subtitle
        const textWrapper = document.createElement('span');
        textWrapper.className = iconUrl
          ? 'tabs-nav-button-text-wrapper visually-hidden'
          : 'tabs-nav-button-text-wrapper';

        const titleEl = document.createElement('span');
        titleEl.className = titleStyle ? `tabs-nav-button-text ${titleStyle}` : 'tabs-nav-button-text';
        titleEl.textContent = title;
        textWrapper.appendChild(titleEl);

        if (subtitle) {
          const subtitleSpan = document.createElement('span');
          subtitleSpan.className = 'tabs-nav-button-sub-content';
          subtitleSpan.textContent = subtitle;
          textWrapper.appendChild(subtitleSpan);
        }

        button.appendChild(textWrapper);
        this.nav.appendChild(button);
        this.buttons.push(button);
      }
    }

    bindEvents() {
      const signal = this.abortController.signal;

      // Button clicks - use event delegation
      this.nav.addEventListener(
        'click',
        (e) => {
          const button = e.target.closest('[data-tabs-button]');
          if (!button) return;

          const index = parseInt(button.dataset.tabsButton, 10);
          this.switchToTab(index);
        },
        { signal },
      );

      // Keyboard navigation
      this.tabs.addEventListener(
        'keydown',
        (e) => {
          // Only act on keys pressed on the tab buttons themselves — Arrow/Home/End
          // bubbling from focusable content inside a panel must not switch tabs.
          if (!e.target.closest('[data-tabs-button]')) return;

          switch (e.key) {
            case 'ArrowLeft':
              e.preventDefault();
              this.previousTab();
              break;
            case 'ArrowRight':
              e.preventDefault();
              this.nextTab();
              break;
            case 'Home':
              e.preventDefault();
              this.switchToTab(0);
              break;
            case 'End':
              e.preventDefault();
              this.switchToTab(this.totalTabs - 1);
              break;
            default:
              return;
          }

          // Roving tabindex: DOM focus must follow selection (ARIA tabs
          // keyboard model) — without this, focus stays stranded on the
          // previous button, which just became tabindex="-1".
          this.buttons?.[this.currentTab]?.focus();
        },
        { signal },
      );

      // Keyboard navigation is handled on the generated tab buttons.
    }

    switchToTab(index) {
      if (index === this.currentTab || index < 0 || index >= this.totalTabs) return;
      if (this.isAnimating) return;

      this.isAnimating = true;
      const newItem = this.items[index];

      // Measure new tab's height using scrollHeight (works on absolute positioned elements)
      const newHeight = newItem.scrollHeight;

      // Update tab states (triggers CSS transitions for opacity/transform)
      this.currentTab = index;
      this.updateTabs();

      // Animate height - CSS transition handles the animation
      this.applyContentHeight(newHeight);

      // Reset animating flag after CSS transition completes
      const transitionDuration = parseFloat(getComputedStyle(this.content).transitionDuration) * 1000 || 400;
      setTimeout(() => {
        this.syncHeight();
        this.isAnimating = false;
      }, transitionDuration);
    }

    nextTab() {
      this.switchToTab((this.currentTab + 1) % this.totalTabs);
    }

    previousTab() {
      this.switchToTab((this.currentTab - 1 + this.totalTabs) % this.totalTabs);
    }

    updateTabs() {
      // Guard: buttons may not exist during early initialization
      if (!this.buttons) return;

      // In mobile dropdown mode the tablist is hidden and the panels behave
      // as an accordion driven by their own toggles — tab/tabpanel roles
      // would give assistive tech the wrong interaction model there.
      const isAccordion = this.isMobileView && this.hasMobileDropdown;
      isAccordion ? this.nav.removeAttribute('role') : this.nav.setAttribute('role', 'tablist');

      // Update buttons and content items
      for (let i = 0; i < this.totalTabs; i++) {
        const isActive = i === this.currentTab;
        const button = this.buttons[i];
        const item = this.items[i];

        button.classList.toggle('active', isActive);
        item.classList.toggle('active', isActive);

        if (isAccordion) {
          button.removeAttribute('role');
          button.removeAttribute('aria-selected');
          item.removeAttribute('role');
          item.removeAttribute('aria-labelledby');
          // All accordion items are visible and interactive
          item.removeAttribute('aria-hidden');
        } else {
          button.setAttribute('role', 'tab');
          button.setAttribute('aria-selected', isActive);
          button.setAttribute('tabindex', isActive ? '0' : '-1');
          item.setAttribute('role', 'tabpanel');
          item.setAttribute('aria-labelledby', button.id);
          item.setAttribute('aria-hidden', !isActive);
        }
      }
    }

    destroy() {
      this.abortController.abort();
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }

  // Map to store tabs instances
  const tabsInstances = new Map();

  // Initialize tabs
  const initTabs = (element) => {
    const blockId = element.dataset.blockId;

    // Destroy existing instance if present
    if (tabsInstances.has(blockId)) {
      tabsInstances.get(blockId).destroy();
      tabsInstances.delete(blockId);
    }

    // Create new instance
    const tabsInstance = new Tabs(element);
    tabsInstances.set(blockId, tabsInstance);
  };

  // Initialize all tabs on page load
  document.addEventListener('DOMContentLoaded', () => {
    const tabsElements = document.querySelectorAll('[data-tabs]');
    tabsElements.forEach((tabs) => initTabs(tabs));
  });

  // Reinitialize when section loads (also used by combined listing morph)
  document.addEventListener('shopify:section:load', (event) => {
    const tabsElements = event.target.querySelectorAll('[data-tabs]');
    tabsElements.forEach((tabs) => initTabs(tabs));
  });

  // Theme editor support
  if (Shopify.designMode) {
    // Reinitialize when block is selected (settings might have changed)
    document.addEventListener('shopify:block:select', (event) => {
      const tabs = event.target.closest('[data-tabs]');
      if (tabs) {
        initTabs(tabs);
      }
    });

    // Cleanup when section unloads
    document.addEventListener('shopify:section:unload', (event) => {
      const tabsElements = event.target.querySelectorAll('[data-tabs]');
      tabsElements.forEach((tabs) => {
        const blockId = tabs.dataset.blockId;
        if (tabsInstances.has(blockId)) {
          tabsInstances.get(blockId).destroy();
          tabsInstances.delete(blockId);
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["utility-dr-banner"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const forms = document.querySelectorAll('.utility-dr-banner__form');

    for (const form of forms) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        form.classList.add('is-submitted');
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
